if (!customElements.get('dl-guide-preview')) {
  customElements.define('dl-guide-preview', class extends HTMLElement {
    connectedCallback() {
      if (this.previewReady) return;
      this.previewReady = true;
      this.zoomed = false;
      this.buttons = [...this.querySelectorAll('[data-dl-sample]')];
      this.panels = [...this.querySelectorAll('[data-dl-panel]')];
      this.zoomButton = this.querySelector('[data-dl-zoom]');
      this.buttons.forEach(button => button.addEventListener('click', () => this.selectSample(button.dataset.dlSample)));
      this.zoomButton?.addEventListener('click', () => this.setZoom(!this.zoomed));
      const dialog = this.closest('dialog');
      if (dialog) {
        this.openObserver = new MutationObserver(() => {
          if (dialog.open) dialog.scrollTop = 0;
        });
        this.openObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      }
      dialog?.addEventListener('close', () => {
        this.selectSample('1');
        dialog.scrollTop = 0;
      });
    }
    selectSample(index) {
      this.setZoom(false);
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dlSample === index)));
      this.panels.forEach(panel => { panel.hidden = panel.dataset.dlPanel !== index; });
    }
    setZoom(zoomed) {
      this.zoomed = zoomed;
      this.classList.toggle('is-zoomed', zoomed);
      this.zoomButton?.setAttribute('aria-pressed', String(zoomed));
      const states = { '[data-dl-zoom-in]': zoomed, '[data-dl-zoom-out]': !zoomed, '[data-dl-fit-hint]': zoomed, '[data-dl-zoom-hint]': !zoomed };
      Object.entries(states).forEach(([selector, hidden]) => { const element = this.querySelector(selector); if (element) element.hidden = hidden; });
      this.querySelectorAll('.dl-sample-reader').forEach(reader => { reader.scrollTop = 0; reader.scrollLeft = 0; });
    }
  });
}
